import {
  Component,
  OnInit,
  OnChanges,
  ChangeDetectionStrategy,
  SimpleChanges,
  ViewChild,
  Input,
  ViewEncapsulation,
  TemplateRef,
  EventEmitter,
  Output,
} from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { BoobleModalService } from 'booble-modal';
import { ActivatedRoute } from '@angular/router';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { GenericBottomSheetComponent } from 'src/app/shared/components/generic-bottom-sheet/generic-bottom-sheet.component';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { RemoveContactConfirmComponent } from '../../modals/remove-contact-confirm/remove-contact-confirm.component';
import { ContactDetailsComponent } from '../../modals/contact-details/contact-details.component';
import { AddContactComponent } from '../../modals/add-contact/add-contact.component';
import { ContactAccountDto } from 'src/app/domain/models/dto/contact-account.dto';

@Component({
  selector: 'app-table-contacts-component',
  templateUrl: 'table.component.html',
  styleUrls: ['table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableContactsComponent implements OnInit, OnChanges {
  isPopoverOpen: boolean = false;

  popoverStates: { [key: number]: boolean } = {};
  currency: any;
  tenant: string = '';
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  private readonly notifier: NotifierService;
  moedas = Moedas;
  isMobile: boolean;

  @Input() displayedColumns: string[];
  @Input() pageNumber: number = 0;
  @Input() pageSize: number = 10;
  @Output() pageChange = new EventEmitter<{
    pageNumber: number;
    pageSize: number;
  }>();

  selection = new SelectionModel<any>(true, []);
  public dataSource: MatTableDataSource<ContactAccountDto>;

  @ViewChild('bottomSheetContent') bottomSheetContent: TemplateRef<any>;
  @Input() data: ContactAccountDto[];

  constructor(
    private modalService: BoobleModalService,
    private ordersService: OrdersService,
    private bottomSheet: MatBottomSheet,
    notifierService: NotifierService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.initializeTable();
  }

  openBottomSheet() {
    this.bottomSheet.open(GenericBottomSheetComponent, {
      data: { content: this.bottomSheetContent },
    });
  }

  togglePopover(rowId: number) {
    this.popoverStates[rowId] = !this.popoverStates[rowId];
  }

  ngAfterViewInit(): void {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      const currentData = changes['data'].currentValue;
      this.dataSource = new MatTableDataSource(
        (currentData || []).sort((a, b) =>
          a.senderReceiverName?.localeCompare(b.senderReceiverName)
        )
      );
      this.initializeTableSort();

      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
    }
  }

  initializeTableSort() {
    if (this.sort) {
      this.sort.active = 'id';
      this.sort.direction = 'desc';
      this.dataSource.sort = this.sort;
    }
  }

  private initializeTable() {
    this.dataSource = new MatTableDataSource(
      (this.data || []).sort((a, b) =>
        a.senderReceiverName?.localeCompare(b.senderReceiverName)
      )
    );
    this.dataSource.paginator = this.paginator;
  }

  onPageChange(event: { pageIndex: number; pageSize: number }) {
    const { pageIndex, pageSize } = event;

    this.pageNumber = pageIndex;
    this.pageSize = pageSize;

    sessionStorage.setItem('saved-contacts-page-size', pageSize.toString());
    sessionStorage.setItem('saved-contacts-page-number', pageIndex.toString());

    this.pageChange.emit({ pageNumber: pageIndex, pageSize });
  }

  openRemoveContactModal(contactId: number) {
    this.modalService.present(RemoveContactConfirmComponent, contactId);
  }

  openContactDetails(contact: ContactAccountDto) {
    this.modalService.present(ContactDetailsComponent, contact);
  }

  onRowToggled(row: any) {
    this.selection.toggle(row);
  }

  openAddContactModal(data: any) {
    this.modalService.present(AddContactComponent, data);
  }

  isAllSelected() {
    return this.selection.selected?.length == this.dataSource.data.length;
  }

  toggleAll() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.select(...this.dataSource.data);
    }
  }

  getCurrencyIcon(currency: any): string {
    const moeda = this.moedas.find((m) => m.id === currency.id);
    return moeda?.icon || 'usd';
  }

  getCurrencyDescription(currency: any): string {
    const moeda = this.moedas.find((m) => m.id === currency.id);
    return moeda?.description || currency.description;
  }
}
